import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';

/**
 * UnconfiguredPage — 系统未配置整页提示 (v0.5.8, 辉哥 9/25 10:14 拍板)
 *
 * 设计图 (option-A-v0578-unconfigured.html + option-A-v0578-desktop-unconfigured.html):
 *   - mobile: 全屏提示 (header / nav tabs / 学员列表 全部隐藏)
 *   - desktop: 720px 居中, 同样全屏覆盖
 *   - icon (警告 triangle) + 标题"系统尚未配置完成" + subtitle + 缺失配置详情卡 + 联系管理员按钮
 *
 * 触发条件 (ConfigCheckController):
 *   - scheduler-role-student-group.group / coach / sales 任何一个 setting 为空 / 对应 group id 不存在
 *
 * 数据:
 *   - props.missing: array of {key: 'student'|'coach'|'sales', value: number|null, ok: false, display: string}
 *   - props.all_configs: 3 行完整状态 (用于详情卡)
 *
 * 跟 CardTemplatesTab 的"未配置 placeholder"是不同定位:
 *   - CardTemplatesTab 单 tab 内的空状态
 *   - UnconfiguredPage 是整个 scheduler 主页不可用的整页提示 (任何人都能看)
 */
export default class UnconfiguredPage extends Component {
  view() {
    const missing = this.attrs.missing || [];
    const allConfigs = this.attrs.allConfigs || [];
    return m("div", {
      className: "ZS-unconfigured-wrap"
    }, m("div", {
      className: "ZS-unconfigured-inner"
    }, m("div", {
      className: "ZS-unconfigured-icon"
    }, m("i", {
      className: "fas fa-triangle-exclamation",
      "aria-hidden": "true"
    })), m("div", {
      className: "ZS-unconfigured-title"
    }, app.translator.trans('ziven-scheduler.forum.unconfigured.title')), m("div", {
      className: "ZS-unconfigured-subtitle"
    }, app.translator.trans('ziven-scheduler.forum.unconfigured.subtitle')), m("div", {
      className: "ZS-unconfigured-detail"
    }, m("div", {
      className: "ZS-unconfigured-detail-title"
    }, app.translator.trans('ziven-scheduler.forum.unconfigured.missing-title')), allConfigs.map(c => m("div", {
      className: "ZS-unconfigured-detail-row",
      key: c.key
    }, m("span", {
      className: "ZS-unconfigured-detail-key"
    }, app.translator.trans('ziven-scheduler.forum.unconfigured.key-' + c.key)), m("span", {
      className: 'ZS-unconfigured-detail-val ' + (c.ok ? 'ok' : 'missing')
    }, c.display)))), m("div", {
      className: "ZS-unconfigured-actions"
    }, m("a", {
      className: "ZS-unconfigured-action",
      href: app.forum.attribute('adminUrl') || '#',
      target: app.forum.attribute('adminUrl') ? '_blank' : '_self'
    }, m("i", {
      className: "fas fa-arrow-right-from-bracket",
      "aria-hidden": "true"
    }), app.translator.trans('ziven-scheduler.forum.unconfigured.contact')))));
  }
}
flarum.reg.add('ziiven-ziven-scheduler', 'forum/components/UnconfiguredPage', UnconfiguredPage);